import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import SearchButton from "../../components/SearchButton/SearchButton";
import AToZ from "../../components/AToZ";
import ToggleUnlock from "../../components/ToggleUnlock/ToggleUnlock";
import Table from "../../components/Table2";
import noData from "../../assets/images/svg/noData.svg";
import Modal from "../../components/Modal";
import UnlockAccModal from "../../components/UnlockAcc/UnlockAccModal";
import { observer } from "mobx-react";
import { getDefaultImageOrImage } from "../../utils/functions";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import SortTable2 from "../../utils/Hooks/SortTable2";
import AuthStore from "../../store/AuthStore";
import ProfileStore2 from "../../store/ProfileStore2";
import PageTitle from "../../components/PageTitle/PageTitle";
import { noSearchResult } from "../../utils/constants";
import SearchResult from "../../components/SearchButton/SearchResult";
import { useMemo } from "react";
import EmptyDataText from "../../components/EmptyDataText/EmptyDataText";
import PageHeading from "../../components/PageHeading/PageHeading";

const UnlockAccount = observer(() => {
  const [openModal, setOpenModal] = useState(false);
  const [search, setSearch] = useState("");
  const [modalConfig, setModalConfig] = useState(undefined);
  const [step, setStep] = useState(0);
  const [lockedAccountImages, setImages] = useState({});
  const [lastTableAction, setLastTableAction] = useState("");
  const [searchMessage, setSearchMessage] = useState("");

  const lockedImages = ProfileStore2.lockedAccountImages;

  const { isAscending, key1, arrData, setKeyForOrdering } = SortTable2(
    ProfileStore2.lockedAccounts,
    { key1: "client", key2: "full_name" },
    true,
  );

  useEffect(() => {
    setImages(ProfileStore2.lockedAccountImages);
  }, [lockedImages]);

  const instrumentNameCellRenderer = (_, data, key) => {
    return (
      <div className="reason_renderer">
        {data.reason ? (
          <p>{data?.reason}</p>
        ) : (
          <EmptyDataText text={"No Data"} />
        )}
      </div>
    );
  };

  const filteredData = useMemo(() => {
    return arrData?.filter((eachData) => {
      return eachData?.client?.full_name
        ?.toLowerCase()
        ?.includes(search?.toLowerCase());
    });
  }, [arrData, search]);

  useEffect(() => {
    ProfileStore2.getLockedAccounts();
  }, []);

  useEffect(() => {
    if (lastTableAction === "search") {
      setSearchMessage(
        filteredData.length
          ? `${filteredData.length} results found for ${
              search || "Empty search input"
            }`
          : `${noSearchResult} ${search}`,
      );
    }
  }, [filteredData]);

  const userRenderer = (_, data) => {
    return (
      <div className="user_rendere">
        {getDefaultImageOrImage({
          clientName: data?.client?.full_name,
          imageSrc: lockedAccountImages?.[data.client?.user_id],
          imgStyle: { width: "61.9px", height: "61.9px", borderRadius: "22px" },
          defaultStyle: { width: "61px", height: "61px", borderRadius: "22px" },
        })}
        <img src={data?.blocked_account?.img} alt="" />
        <p className="user_data">
          <span>{data?.client?.full_name}</span>
          <span>{data.client.isprimary ? "PRIMARY" : ""}</span>
        </p>
      </div>
    );
  };

  const time1Renderer = (_, data) => {
    let dateStr, timeStr, timeStrDisp, dateDispArr;
    if (data && data.lockDate) {
      dateStr = data?.lockDate?.substring(0, 11);
      timeStr = data?.lockDate?.substring(12);
      const timeArr = timeStr?.split(":");
      timeStrDisp = timeArr[0].concat(":", timeArr[1], timeArr[3].substring(3));
      dateDispArr = dateStr?.split(" ");
    }

    return !!dateStr && !!timeStr ? (
      <div className="time_render">
        <p>
          {timeStrDisp}
          <span></span>{" "}
          {`${dateDispArr[1]} ${dateDispArr[0]} ${dateDispArr[2]}`}
        </p>
      </div>
    ) : (
      <>
        <EmptyDataText text={"No Data"} />
      </>
    );
  };

  const handleToggle = (e, data) => {
    setStep(0);
    setModalConfig(data);
    setOpenModal(true);
  };

  const btnCellRenderer = (_, data) => {
    return (
      <div className="btn_render">
        <ToggleUnlock
          data={data}
          isChecked={false}
          handleToggle={(e, data) => handleToggle(e, data)}
        />
      </div>
    );
  };

  const columns = [
    {
      label: "Blocked Account",
      key: "client",
      sortable: false,
      width: "345px",
      cellRenderer: userRenderer,
    },
    {
      label: "Time & Day",
      key: "lockDate",
      sortable: false,
      width: "200px",
      cellRenderer: time1Renderer,
    },

    {
      label: "Reason",
      key: "reason",
      sortable: false,
      width: "730px",
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Action",
      key: "action",
      sortable: false,
      cellRenderer: btnCellRenderer,
    },
  ];

  const EmptyState = (tab) => {
    return (
      <div className="unlock_empty_state">
        <div className="image_container">
          <img width="100%" src={noData} alt="transaction icon" />
        </div>
        <div className="title_container">
          You do not have any Blocked accounts
        </div>
      </div>
    );
  };

  const handleKey = () => {
    setLastTableAction("sort");
    setKeyForOrdering({ key1: "client", key2: "full_name" });
  };

  return (
    <div>
      <PageTitle title={"Unlock Accounts"} />
      {AuthStore.isLoadingFullScreen ? (
        <LoadingScreen />
      ) : (
        <>
          {" "}
          <Header type={"profile"} />
          <div className="unlock_outside_main">
            <PageHeading
              headingClass="all_pages_head"
              headingText="Unlock Accounts"
            />
            <div className="search_div">
              <div onClick={handleKey}>
                <AToZ isSort={isAscending ? "asc" : ""} />
              </div>
              <SearchButton
                search={search}
                setSearch={(data) => {
                  setLastTableAction("search");
                  setSearch(data);
                }}
                width={"423px"}
                ariaLabel="Search By Clients Name"
              />
            </div>
            <SearchResult searchMessage={searchMessage} />

            <Table
              data={filteredData}
              columns={columns}
              tableClass="equity_summary_table12"
              EmptyStateBody={<EmptyState />}
              showColumnsOnly={true}
              sortKey={key1}
              isAscending={isAscending}
              handleSort={(key) =>
                setKeyForOrdering({ key1: key, key2: "full_name" })
              }
            />
          </div>
          {!!modalConfig && (
            <Modal
              onClose={() => setOpenModal(false)}
              open={openModal}
              width="438px"
              minWidth="438px"
              modalContainerClass="padding30"
            >
              <UnlockAccModal
                onClose={() => setOpenModal(false)}
                modalConfig={modalConfig}
                img={getDefaultImageOrImage({
                  clientName: modalConfig?.client?.full_name,
                  imageSrc: lockedAccountImages?.[modalConfig.client?.user_id],
                  imgStyle: {
                    width: "98px",
                    height: "98px",
                    borderRadius: "37px",
                    objectFit: "cover",
                  },
                  defaultStyle: {
                    width: "98px",
                    height: "98px",
                    borderRadius: "37px",
                  },
                })}
                step={step}
                setStep={(data) => setStep(data)}
                setLastTableAction={() => setLastTableAction("")}
              />
            </Modal>
          )}
        </>
      )}
    </div>
  );
});

export default UnlockAccount;
